export default __webpack_public_path__ + "static/media/us-circle-flag.a91c6179.png";